import { useCallback, useEffect } from 'react';
import { useAsync } from '@nxsys/hooks/useAsync';
import { getAnalyticsEmployeeStatus } from '@nxsys/services/api/analytics';
import type {
  GetAnalyticsEmployeeStatusResponse,
  GetAnalyticsPayslipsProcessedListParams,
} from '@nxsys/types/api/analytics';
import { showMessage } from '@nxsys/utils/message';
import { getErrorMessage } from '@nxsys/utils/getErrorMessage';

type UseGetEmployeeStatusReturn = {
  loading: boolean;
  error: Error | null;
  data: GetAnalyticsEmployeeStatusResponse | null;
  fetchEmployeeStatus: () => Promise<void>;
};

export const useGetEmployeeStatus = (
  params?: GetAnalyticsPayslipsProcessedListParams,
): UseGetEmployeeStatusReturn => {
  const {
    loading,
    error,
    value: data,
    run,
  } = useAsync<GetAnalyticsEmployeeStatusResponse, void>(() =>
    getAnalyticsEmployeeStatus(params),
  );

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  const fetchEmployeeStatus = useCallback(async () => {
    await run(undefined);
  }, [run]);

  return {
    loading,
    error,
    data,
    fetchEmployeeStatus,
  };
};
